
import styled from "styled-components";

export const StyledIntegrationChoice = styled.div<{ chosen: boolean }>`
    font-family: ${p => p.theme.typography.body1.fontFamily};
    font-size: ${p => p.theme.typography.body1.fontSize};
    font-weight: ${p => p.theme.typography.body1.fontWeight};
    color: ${p => p.chosen ? p.theme.palette.positive.main : p.theme.palette.danger.main};
    cursor: pointer;
`
